import React, { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { Link } from "react-router-dom";

function EmployerHeader({ is_reviewer }) {
  let { user, logoutUser } = useContext(AuthContext);

  return (
    <div>
      <nav
        className="navbar navbar-expand-lg bg-dark mb-5"
        data-bs-theme="dark"
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            HAMSIE EXPENSES
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Invoices
                </Link>
              </li>
              {!is_reviewer && (
                <>
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/companies"
                    >
                      Companies
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/categories"
                    >
                      Categories
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/archived"
                    >
                      Archived Invoices
                    </Link>
                  </li>
                </>
              )}
            </ul>
            {/* <form className="d-flex" role="search">
                <input className="form-control mr-sm-2 me-2" type="search" placeholder="Search Invoice" aria-label="Search" />
                <button className="btn btn-outline-success my-2 my-sm-0 me-2" type="submit">Search</button>
            </form> */}
            <button className="btn btn-outline-danger" onClick={logoutUser}>
              Logout
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default EmployerHeader;
